module.exports = __webpack_public_path__ + "img/xzls.804b4cc1.png";